import { Toggle } from '@cimplico/components';
import { formatMixedCase } from '../../../../utilities/formatting';
import { FieldType } from '../../../../types/custom-worksheet-v2';
import { useDispatch } from 'react-redux';
import { editPropertyDetails } from '../../store/slice';

type AdditionalFieldTypesProps = {
    sectionId: string;
    types: FieldType[];
};

function AdditionalFieldTypes({ sectionId, types }: AdditionalFieldTypesProps): JSX.Element {
    const dispatch = useDispatch();

    function handleToggleType(type: FieldType): void {
        let updatedFieldTypes = types;
        if (updatedFieldTypes.includes(type)) {
            updatedFieldTypes = updatedFieldTypes.filter((t) => t !== type);
        } else {
            updatedFieldTypes = [...updatedFieldTypes, type];
        }

        dispatch(
            editPropertyDetails({
                id: `${sectionId}.additionalFields`,
                value: updatedFieldTypes.length === 0 ? null : updatedFieldTypes,
            })
        );
    }

    return (
        <>
            {Object.values(FieldType)
                .filter((fieldType) => fieldType !== FieldType.DROPDOWN)
                .map((type) => (
                    <div className="flex items-start justify-between py-1 pl-4" key={type}>
                        <p className="text-gray-700 text-xs font-medium">{formatMixedCase(type)}</p>
                        <Toggle type="short" defaultEnabled={types.includes(type)} onToggle={(): void => handleToggleType(type)} />
                    </div>
                ))}
        </>
    );
}

export default AdditionalFieldTypes;
